import React from "react";
import { Card, CardContent } from "../../../common/components/Card/index";
import { Button } from "../../../common/components/UpdatedButton";
import { Button as MuiButton } from "../../../common/components/Button";
import styles from "./index.module.scss";
import RegistrationHeader from "../RegistrationHeader";
import { ProgramDetails } from "../../../pages/Registration";
import { userRegistration } from "../../../utils/registrationUtils";
import logo from "../../../assets/images/hdb-img.png";
import { getItemInLocalStorage } from "../../../services/localStorage";
import MahatriaLogo from "../../../assets/images/act-mahatria-logo.svg";
import { endPoints } from "../../../constants/urlConstants";
import { getCall } from "../../../services/apiService";
import { downloadFileFromUrl } from "../../../utils/commonFunctions";
import { CANCELLED, OFFLINE, OFFLINE_PENDING, ONLINE, WARNING_MESSAGES } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { combineSlices } from "@reduxjs/toolkit";
import { highlightMahatriaAndInfinitheism } from "../../../common/components/HighlightMahatriaInfinitheism";
import { REGISTRAITON_SUCCESS } from "../../../constants/registration";

interface PersonalInfo {
  fullName?: string;
  email?: string;
  mobile?: string;
}

interface PaymentInfo {
  invoiceName?: string;
  amount?: number;
}

interface Event {
  requiresApproval: boolean;
  isPaid: boolean;
  name: string;
}

interface RegistrationSuccessProps {
  event: ProgramDetails | null;
  personalInfo?: userRegistration | null;
  paymentInfo?: PaymentInfo;
  onBack: () => void;
  handleEditData: () => void;
  fillAdditionalInfo?: boolean;
}
const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({
  event,
  personalInfo,
  onBack,
  handleEditData,
  fillAdditionalInfo = false,
}) => {
  const navigate = useNavigate();
  const seekerDetails = getItemInLocalStorage("seekerDetails");
  const seekerName = seekerDetails?.legalFullName || seekerDetails?.fullName || seekerDetails?.firstName || "";
  function formatDateToWeekDate(dateString: string) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    const weekday = date.toLocaleString("default", { weekday: "long" });
    return `${day < 10 ? "0" + day : day} ${month} ${year} (${weekday})`;
  }

  const onInvoiceClick = (registrationId: number) => {
    console.log("Invoice clicked, onInvoiceClick", registrationId);
    getCall(endPoints.invoiceDownload(registrationId), undefined, false)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          console.log("response format:", response.data.data);
          downloadFileFromUrl(response?.data?.data?.invoicePdfUrl, response?.data?.data?.fileName);
        } else {
          console.error("Failed to download invoice:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error downloading inv  oice:", error);
      });
    console.log("Invoice clicked, onInvoiceClick completed");
  };
  return (
    <div className={styles.container}>
      {/* Banner */}
      {/* <div className={styles.banner}>
                        <RegistrationHeader/>
                        <div className={styles.bannerContent}>
                        <div className={styles.bannerText}>
                        <h1 className={styles.bannerTitle}>Registration Complete</h1>
                        <p className={styles.bannerSubtitle}>{personalInfo?.fullName}, Thank you for registering the {event?.name}</p>
                       </div>
                        </div>
                      </div> */}

      <div className={styles.content}>
        {/* <Card className={styles.card}>
          <CardContent className={styles.cardContent}>
            <div className={styles.registrationSuccessHeader}>
              <RegistrationHeader />
            </div>
            <div className={styles.successSection}>
              <h2 className={styles.successTitle}> */}
        {/* {personalInfo?.program?.requiresApproval ? "Awaiting Mahatria's Approval" : "You're All Set!"}
         */}
        {/* We acknowledge your registration
              </h2>
              <p className={styles.regDescription}>
                a residential experience with{" "}
                <span className={styles.mahatriaText}>Mahatria.</span>
                <br />
                Your provisional registration number is{" "}
                <span className={styles.registrationId}>
                  {personalInfo?.registrationSeqNumber}
                </span>
                <br />
                Note: Payment is subject to realisation. A confirmation mail
                along with
                <br />
                the invoice will follow upon payment realisation.
                <br />
                Let this residential experience magnetise the best of everything
                in life.
              </p>
            </div>
            <div className={styles.buttonGroup}>
            {
            fillAdditionalInfo && personalInfo?.travelPlans.length ==0 && personalInfo?.travelInfo.length == 0 && event?.involvesTravel && <MuiButton 
                onClick={() => handleEditData()}
                 buttonClassName={styles.homeButton}
              >
               go to travel
              </MuiButton>} */}
        {/* <Button className={styles.calendarButton}>
                <span className={styles.calendarButtonText}>Add to Calendar</span>
              </Button> */}
        {/* <Button 
                variant="outline" 
                className={styles.invoiceButton}
              >
                Download Invoice
              </Button> */}
        {/* <Button variant="outline" className={styles.invoiceButton}>
                download invoice
              </Button> */}
        {/* <Button
                variant="outline"
                className={styles.invoiceButton}

              >
                new registration
              </Button> */}
        {/* <Button
              variant="outline"
                className={styles.invoiceButton}
                onClick={() => onBack()}
              >
                go to home
              </Button>
            </div>
          </CardContent>
        </Card> */}
        <div className={styles.card}>
          {/* <p className={styles.acknowledgmentSection}>
            We acknowledge your registration for
          </p> */}
          <div className={styles.logoProgramContainer}>
            <div className={styles.logoContainer}>
              <img className={styles.logo} src={MahatriaLogo} />
            </div>
            <div className={styles.programName}>
             {highlightMahatriaAndInfinitheism(personalInfo?.program?.name)}
            </div>
          </div>
          {
            personalInfo?.registrationStatus !== CANCELLED && personalInfo?.isFreeSeat && (
              <div className={styles.successSection}>
                <span className={styles.acknowledgmentSpan}>
                  Dear infinitheist {seekerName}
                </span>
                <div className={styles.acknowledgmentText}>
                Your registration for {highlightMahatriaAndInfinitheism(personalInfo?.program?.name)} is successful.
                </div>
              </div>
            )
          }
          {
            personalInfo?.registrationStatus == CANCELLED && (
              <div className={styles.successSection}>
                <span className={styles.acknowledgmentSpan}>
                  Dear infinitheist {highlightMahatriaAndInfinitheism(seekerName)}
                </span>
                <div className={styles.acknowledgmentText}>
                {WARNING_MESSAGES.REG_CANCELLED[0]}
                </div>
              </div>
            )
          }
          {
            personalInfo?.registrationStatus !== CANCELLED && personalInfo?.paymentDetails[0]?.paymentMode === ONLINE && (
              <div className={styles.successSection}>
                <span className={styles.acknowledgmentSpan}>
                  Dear infinitheist {seekerName}
                </span>
                <div className={styles.acknowledgmentText}>
                Payment towards {highlightMahatriaAndInfinitheism(personalInfo?.allocatedProgram?.name)} - {formatDateToWeekDate(personalInfo?.allocatedProgram?.startsAt)} to {formatDateToWeekDate(personalInfo?.allocatedProgram?.endsAt)} is successful.
                </div>
              </div>
            )
          }

         {personalInfo?.registrationStatus !== CANCELLED && personalInfo?.paymentDetails[0]?.paymentMode === OFFLINE &&
          <div className={styles.successSection}>
            
            <span className={styles.acknowledgmentSpan}>
              Dear infinitheist {seekerName}
            </span>
           {/* <span className={styles.mahatria}>Mahatria.</span> */}
            {/* <div className={styles.acknowledgmentText}>Your provisional registration number is {personalInfo?.registrationSeqNumber}</div> */}
            {personalInfo?.allocatedProgram ? <div className={styles.acknowledgmentText}>
            {REGISTRAITON_SUCCESS.ACKNOWLEDGE}{highlightMahatriaAndInfinitheism(personalInfo?.allocatedProgram?.name)} - {formatDateToWeekDate(personalInfo?.allocatedProgram?.startsAt)} to {formatDateToWeekDate(personalInfo?.allocatedProgram?.endsAt)}.
            </div>
            :
            <div className={styles.acknowledgmentText}>
              {highlightMahatriaAndInfinitheism(WARNING_MESSAGES.REJECTED[0])}  
            </div>}
            {/* <div className={styles.acknowledgmentText}>Let this residential experience magnetise the best of everything in life.</div> */}
            <div className={styles.acknowledgmentText}>
              {/* Note: Cheques are subject to realization */}
              {
                personalInfo?.paymentDetails[0]?.offlineMeta.paymentMethod === "Cheque" && (
                  <span className={styles.acknowledgmentSpan}>
                    Note: Cheques are subject to realization
                  </span>
                ) 
              }
            </div>
            
    
          </div>}
      
        </div>
        <div className={styles.buttonGroup}>
          {!personalInfo?.isFreeSeat && personalInfo?.paymentDetails[0]?.paymentStatus !=
            OFFLINE_PENDING &&  personalInfo?.registrationStatus != CANCELLED && (
            <MuiButton
              buttonClassName={styles.invoiceButton}
              onClick={() => onInvoiceClick(personalInfo?.id)}
            >
              download invoice
            </MuiButton>
          )}

          <MuiButton
            onClick={() => onBack()}
            buttonClassName={styles.invoiceButton}
          >
          home
          </MuiButton>
          {/* {
            fillAdditionalInfo && personalInfo?.travelPlans.length ==0 && personalInfo?.travelInfo.length == 0 && event?.involvesTravel &&
              
              
              
              <MuiButton
                // variant="outline"
                buttonClassName={styles.homeButton} 
                onClick={() => handleEditData()}
              >
              travel plan
              </MuiButton>} */}
          {/* <Button
                variant="outline"
                className={styles.invoiceButton}

              >
                go to travel
              </Button> */}

          {!(
            fillAdditionalInfo &&
            personalInfo?.travelPlans.length == 0 &&
            personalInfo?.travelInfo.length == 0 &&
            event?.involvesTravel
          ) &&
            personalInfo?.registrationStatus != CANCELLED && (
            <MuiButton
              className={styles.invoiceButton}
              buttonClassName={styles.homeButton}
              onClick={() =>
                navigate(
                  `/myspace/programs/summary?programId=${personalInfo?.allocatedProgram?.primaryProgramId}`,
                )
              }
            >
              summary
            </MuiButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
